var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavResumen = function SvgNavResumen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_resumen_svg__Capa_2",
    viewBox: "0 0 34 33.95"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_resumen_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.92 13.09H5.86A5.17 5.17 0 0 1 .69 7.92V5.86C.69 3 3 .69 5.86.69h2.06a5.17 5.17 0 0 1 5.17 5.17v2.06a5.17 5.17 0 0 1-5.17 5.17ZM28.08 13.09h-2.06a5.17 5.17 0 0 1-5.17-5.17V5.86A5.17 5.17 0 0 1 26.02.69h2.06a5.17 5.17 0 0 1 5.17 5.17v2.06a5.17 5.17 0 0 1-5.17 5.17ZM7.92 33.2H5.86a5.17 5.17 0 0 1-5.17-5.17v-2.06a5.17 5.17 0 0 1 5.17-5.17h2.06a5.17 5.17 0 0 1 5.17 5.17v2.06a5.17 5.17 0 0 1-5.17 5.17Z",
    stroke: "#b3b3b3",
    strokeWidth: "1.37px",
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.08 33.2h-2.06a5.17 5.17 0 0 1-5.17-5.17v-2.06a5.17 5.17 0 0 1 5.17-5.17h2.06a5.17 5.17 0 0 1 5.17 5.17v2.06a5.17 5.17 0 0 1-5.17 5.17Z",
    fill: "none",
    strokeLinecap: "round",
    stroke: "#19d3c5",
    strokeWidth: "1.5px"
  }))));
};
export default SvgNavResumen;